import { flow } from '@hcr/utils'

import { createCouponUsedValidity } from './createCouponUsedValidity'

export const createCouponUsedValidityString = flow(createCouponUsedValidity, ({ date, label }) => `${label} ${date}`)
